/**
 * Feel free to write your ES6 code here, it will
 * be transpiled automatically.
 */
import init from './wishlist';

document.addEventListener( 'DOMContentLoaded', init );
